import Manager from "../Manager";

export default function(axios) {
    axios.interceptors.request.use(async (config) => {
        let token = await Manager.getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
};


// WEBPACK FOOTER //
// ./src/common/auth/interceptors/Authorization.js